import { React, useEffect, useRef, useState } from "react";
import Email_Icon from "../assets/images/Email_Icon.png";
import Password_Icon from "../assets/images/Password_Icon.png";
import logo from "../assets/images/user_opt_logo.png";
import { Icon } from "@iconify/react";
import google from "../assets/images/google.png";
import facebook from "../assets/images/facebook.png";
import twitter from "../assets/images/twitter.png";
import check_ from "../assets/images/check.png";
import uncheck from "../assets/images/uncheck.png";
import video from "../assets/vedio/Opt_vedio.mp4";
import { type } from "@testing-library/user-event/dist/type";
import { Link } from "react-router-dom";
import axios, { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { MdErrorOutline } from "react-icons/md";
import { message } from "antd";
import secureLocalStorage from "react-secure-storage";

function UserSignUp() {
  const [showpassword, setshowpassword] = useState(false);
  const [showconfirmpassword, setshowconfirmpassword] = useState(false);
  const [check, setcheck] = useState(false);
  const [userCreds, setUserCreds] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const emailref = useRef(null);
  const passwordref = useRef(null);
  const confirmPasswordref = useRef(null);

const handleSubmit = () => {
    // Perform validation and then submit data
    if (userCreds.password === userCreds.confirmPassword) {
      handleApi();
    }
  };

  const handleApi = () => {
    axios
      .post(`${process.env.REACT_APP_API}/signup`, {
        email: userCreds.email,
        password: userCreds.password,
        confirm_password: userCreds.confirmPassword,
        role: "user",
      })
      .then((response) => {
        console.log(response.data);
        toast.success("Signup Successful");
        navigate("/signin");
      })
      .catch((AxiosError) => {
        console.log(AxiosError);
        if (AxiosError.message === "Request failed with status code 400") {
          toast.error("Email Already Exists");
        } else {
          toast.error("Error Signing up");
        }
      });
  };

  const usercredSchema = Yup.object().shape({
    email: Yup.string()
      .matches(/@gmail.com$/, "Email must be from Gmail domain")
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format")
      .required("Email is required"),
    password: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@\$!%\*?&]{8,}$/,
        "Password must contain at least 8 characters"
      )
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/\d/, "Password must contain at least one digit")
      .matches(
        /[@$!%*?&]/,
        "Password must contain at least one Special characters"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const validateusercreds = async (data) => {
    try {
      // Validate user query data against the schema
      await usercredSchema.validate(data, { abortEarly: false });

      // If validation succeeds, return null
      return null;
    } catch (error) {
      // If validation fails, return an object containing error messages
      return error.inner.reduce((errors, err) => {
        return {
          ...errors,
          [err.path]: err.message,
        };
      }, {});
    }
  };

  const handleClick = async () => {
    // Validate user query data
    const validationErrors = await validateusercreds(userCreds);
    // If there are validation errors, set the errors state
    if (validationErrors) {
      setErrors(validationErrors);
      if (validationErrors.email) {
        emailref.current.focus();
      } else if (validationErrors.password) {
        passwordref.current.focus();
      } else if (validationErrors.confirmPassword) {
        confirmPasswordref.current.focus();
      }
    } else {
      setErrors("");
      handleSubmit();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  return (
    <div className="font-userFont text-[#E3D0A8]">
      <div className="sign_up  overflow-auto h-screen flex justify-center items-center md:items-stretch lg:items-start flex-col md:flex-row ">
        <div className="sign_up_left 	 hidden md:block relative    md:w-[68%]   ">
          <video
            autoPlay
            muted
            loop
            width="100%"
            height="100%"
            playsInline
            className=" h-screen   w-full  object-cover"
          >
            <source src={video} type="video/mp4" className=" h-fit" />
          </video>
          <div className="absolute top-0 left-0  w-full bg-black opacity-50 h-screen"></div>
        </div>
        <div className="sign_up_right h-full flex  flex-col items-center	justify-center		 w-full md:w-[32%]    bg-white pt-7 lg:pt-6 2xl:pt-[60px] px-5 lg:px-7  2xl:px-14 pb-2  ">
          <div className=" w-[200px] md:w-[250px] xl:w-[260px] 2xl:w-[320px] md:h-[60px] 2xl:h-[92px] flex mb-[15px] md:mb-[25px] xl:mb-[30px]  2xl:mb-[50px] justify-center it ">
            <img src={logo} alt="" className="w-full h-full cursor-pointer"  onClick={() => navigate("/")}  />
          </div>

          <form>
            <div className="form-container flex flex-col gap-3 md:gap-4 2xl:gap-7">
              <h2 className=" text-center text-2xl lg:text-4xl 2xl:text-5xl pb-4 md:pb-0 xl-pb-2 text-black  2xl:pb-5 font-semibold ">
                Sign up
              </h2>
              <div className="input items-center flex gap-3 border-2 !border-[#E3D0A8] rounded-xl p-2 md:p-3  2xl:p-[22px] ">
                {" "}
                <img
                  src={Email_Icon}
                  className="w-4 h-4 md:h-auto md:w-auto"
                  alt=""
                />
                <input
                  className="!border-none text-2xl focus:outline-none p-0 border text-black focus:ring-0 w-full placeholder:text-[#E3D0A8]  lg:placeholder:text-xl  2xl:placeholder:text-2xl "
                  type="text"
                  ref={emailref}
                  placeholder="Email"
                  value={userCreds.email}
                  onChange={(e) => {
                    setUserCreds({
                      ...userCreds,
                      email: e.target.value.toLowerCase(),
                    });
                    setErrors({ ...errors, email: "" });
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                />
              </div>
              {errors.email && (
                <p className=" text-[#ff6839]  text-sm   ">{errors.email}</p>
              )}
              <div className="input items-center  flex gap-3 border-2 !border-[#E3D0A8]  rounded-xl p-2 md:p-3 2xl:p-[22px] ">
                {" "}
                <img
                  src={Password_Icon}
                  className="w-4 h-4 md:h-auto md:w-auto"
                  alt=""
                />
                <input
                  className="!border-none text-2xl  focus:outline-none text-black p-0 border focus:ring-0 w-full placeholder:text-[#E3D0A8] lg:placeholder:text-xl  2xl:placeholder:text-2xl  "
                  type={showpassword ? "text" : "password"}
                  placeholder="Password"
                  ref={passwordref}
                  value={userCreds.password}
                  onChange={(e) => {
                    setUserCreds({ ...userCreds, password: e.target.value });
                    setErrors({ ...errors, password: "" });
                  }}
                  onKeyDown={(e) => {
                    handleKeyDown(e);
                  }}
                />
                {showpassword ? (
                  <>
                    <Icon
                      icon="clarity:eye-show-line"
                      color="#E3D0A8"
                      width="25"
                      height="25"
                      onClick={() => {
                        setshowpassword(false);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Icon
                      icon="clarity:eye-hide-line"
                      color="#E3D0A8"
                      width="25"
                      height="25"
                      onClick={() => {
                        setshowpassword(true);
                      }}
                    />
                  </>
                )}
              </div>
              {errors.password && (
                <p className=" text-[#ff6839]  text-sm   ">{errors.password}</p>
              )}
              <div className="">
                <div className="input items-center  flex gap-3 border-2 !border-[#E3D0A8] rounded-xl p-2 md:p-3 2xl:p-[22px] ">
                  {" "}
                  <img
                    src={Password_Icon}
                    className="w-4 h-4 md:h-auto md:w-auto"
                    alt=""
                  />
                  <input
                    className="!border-none text-2xl focus:outline-none text-black p-0 border focus:ring-0 w-full placeholder:text-[#E3D0A8]  lg:placeholder:text-xl  2xl:placeholder:text-2xl  "
                    type={showconfirmpassword ? "text" : "password"}
                    placeholder="Re-enter Password"
                    value={userCreds.confirmPassword}
                    ref={confirmPasswordref}
                    onChange={(e) => {
                      setUserCreds({
                        ...userCreds,
                        confirmPassword: e.target.value,
                      });
                      setErrors({ ...errors, confirmPassword: "" });
                    }}
                    onKeyDown={(e) => {
                      handleKeyDown(e);
                    }}
                  />
                  {showconfirmpassword ? (
                    <>
                      <Icon
                        icon="clarity:eye-show-line"
                        color="#E3D0A8"
                        width="25"
                        height="25"
                        onClick={() => {
                          setshowconfirmpassword(false);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Icon
                        icon="clarity:eye-hide-line"
                        color="#E3D0A8"
                        width="25"
                        height="25"
                        onClick={() => {
                          setshowconfirmpassword(true);
                        }}
                      />
                    </>
                  )}
                </div>
                {errors.confirmPassword && (
                  <p className=" text-[#ff6839]  text-sm mt-3  ">
                    {errors.confirmPassword}
                  </p>
                )}
              </div>
              <div
                className={`bg-[#E3D0A8] text-center px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] `}
                onClick={handleClick}
              >
                Sign up
              </div>

              <p className=" text-sm xl:text-xl text-center text-black">
                Do you have an account?{" "}
                <Link to="/signin">
                  <span className="primary ps-3">Get Started</span>
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UserSignUp;
